import { z } from 'zod';
import { baseModelSchema } from '../../baseModel';
import { IRegionFormValues } from './regionFormValues';

/**
 * Zod schema for validating region data.
 * Extends the base model schema with region-specific fields.
 *
 * @property {string} code - Unique identifier code (max 5 characters)
 * @property {string} name - Name of the region (max 255 characters)
 * @property {number[]} organizationIds - Array of organization IDs associated with this region
 */
export const regionSchema = baseModelSchema.extend({
    code: z.string().nonempty('Code is required').max(5, 'Code can only be up to 5 characters long.'),
    name: z.string().nonempty('Name is required').max(255, 'Name can only be up to 255 characters long.'),
    organizationIds: z.array(z.number()).default([]),
});

/**
 * TypeScript interface representing a Region object.
 * Generated from the Zod schema for type safety.
 */
export type IRegion = z.infer<typeof regionSchema>;

// Convert form values into a valid region object
export function Region(formValues : IRegionFormValues) : IRegion {
    const { organizations } = formValues;

    return regionSchema.parse({
        ...formValues,
        organizationIds: organizations?.map(x => Number(x.value)) ?? [], // Map IOptionType array back to IDs
    });
};
